import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { getRouteUrl, routeConfigs } from '../../constants/route.config';

@Injectable({
  providedIn: 'root',
})
export class ApiErrorHandler {
  constructor(private _router: Router, private _snackBar: MatSnackBar) {}

  public handle(error: HttpErrorResponse) {
    if (error.status === 500) {
      this.showApplicationError(error);
    } else if (error.status === 401 && !error.url?.includes('/auth/login')) {
      this._router.navigateByUrl(routeConfigs.auth.login.path);
    } else if (!error.url?.includes('/auth/login')) {
      this.showApplicationError(error);
    }
  }

  public showError(msg: string) {
    this._snackBar.open(msg, 'Close', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'ig-error-snackbar',
    });
  }

  private showApplicationError(error: HttpErrorResponse) {
    if (!error.message) return;
    if (['/ai-assistant'].some((x) => error.message.includes(x))) {
      // handle in ai-assistant talk box
      return;
    }

    let position: MatSnackBarVerticalPosition = 'top';
    let message = this.getResponseErrorMessage(error) || error.message;
    if (['/travel-buddy'].some((x) => error.message.includes(x))) {
      position = 'bottom';
    }

    this._snackBar.open(message, 'Close', {
      horizontalPosition: 'center',
      verticalPosition: position,
      panelClass: 'ig-error-snackbar',
    });
  }

  private getResponseErrorMessage(error: HttpErrorResponse): string | null {
    const responseBody = error.error;

    if (typeof responseBody === 'string') {
      const message = responseBody.trim();
      return message || null;
    }

    if (!responseBody || typeof responseBody !== 'object') {
      return null;
    }

    for (const value of [responseBody.error, responseBody.message]) {
      if (typeof value === 'string' && value.trim()) {
        return value.trim();
      }
    }

    if (Array.isArray(responseBody.errors)) {
      const messages = responseBody.errors
        .filter((value) => typeof value === 'string' && value.trim())
        .map((value: string) => value.trim());
      return messages.length ? messages.join(' ') : null;
    }

    return null;
  }
}
